import {
  ArrowRight,
  Building2,
  CreditCard,
  FlaskConical,
  Link2,
  ShieldCheck,
} from "lucide-react";

const filters = ["All", "Laboratory", "Insurance", "Pharmacy", "Others"];

const integrations = [
  { id: "core", Icon: Building2, iconWrap: "bg-emerald-100 text-emerald-600" },
  { id: "lab", Icon: FlaskConical, iconWrap: "bg-violet-100 text-violet-600" },
  { id: "insurance", Icon: ShieldCheck, iconWrap: "bg-blue-100 text-blue-600" },
  { id: "link", Icon: Link2, iconWrap: "bg-rose-100 text-rose-600" },
  { id: "pay", Icon: CreditCard, iconWrap: "bg-amber-100 text-amber-600" },
];

export default function IntegrationsPreviewMock() {
  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-2.5 rounded-[14px] bg-[#f4f6fa] p-2.5 sm:gap-3 sm:p-3 md:gap-3.5 md:p-3.5">
      <div>
        <p className="font-display text-[11px] font-bold leading-tight text-slate-900 sm:text-xs md:text-sm">
          All Integrations
        </p>
        <div className="mt-1.5 flex flex-wrap gap-1 sm:mt-2 sm:gap-1.5">
          {filters.map((label) => {
            const active = label === "All";
            return (
              <span
                key={label}
                className={`inline-flex rounded-full px-2 py-0.5 text-[8px] font-semibold sm:px-2.5 sm:text-[9px] md:text-[10px] ${
                  active
                    ? "bg-accent text-white"
                    : "bg-white/90 text-slate-800 ring-1 ring-slate-200/90"
                }`}
              >
                {label}
              </span>
            );
          })}
        </div>
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-5 gap-1 sm:gap-1.5 md:gap-2">
        {integrations.map(({ id, Icon, iconWrap }) => (
          <div
            key={id}
            className="flex min-h-[72px] flex-col items-center justify-between rounded-lg border border-slate-200/90 bg-gradient-to-br from-white via-slate-50/60 to-slate-100/70 px-1 py-2 shadow-sm sm:min-h-[84px] sm:rounded-xl sm:py-2.5 md:min-h-[92px]"
          >
            <div
              className={`flex size-8 items-center justify-center rounded-xl sm:size-9 md:size-10 ${iconWrap}`}
            >
              <Icon className="size-4 sm:size-[18px] md:size-5" strokeWidth={1.85} />
            </div>
            <div className="flex items-center gap-0.5 sm:gap-1">
              <span
                className="size-1.5 shrink-0 rounded-full bg-emerald-500 sm:size-2"
                aria-hidden
              />
              <span className="text-[7px] font-semibold text-emerald-600 sm:text-[8px] md:text-[9px]">
                Connected
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="flex shrink-0 items-center gap-2 rounded-xl bg-sky-100/95 px-2 py-2 ring-1 ring-sky-200/80 sm:gap-2.5 sm:px-2.5 sm:py-2.5 md:gap-3 md:px-3">
        <div
          className="flex size-8 shrink-0 items-center justify-center rounded-xl bg-accent text-[9px] font-bold text-white sm:size-9 sm:text-[10px] md:size-10"
          aria-hidden
        >
          API
        </div>
        <div className="min-w-0 flex-1 text-left">
          <p className="font-display text-[9px] font-bold leading-tight text-slate-900 sm:text-[10px] md:text-xs">
            API-ready platform
          </p>
          <p className="mt-0.5 text-[7px] leading-snug text-slate-600 sm:text-[8px] md:text-[9px]">
            Build, connect, and scale with our secure and flexible APIs.
          </p>
        </div>
        <span className="inline-flex shrink-0 items-center gap-0.5 rounded-lg bg-accent px-1.5 py-1 text-[7px] font-medium text-white shadow-sm sm:gap-1 sm:px-2 sm:py-1.5 sm:text-[8px] md:text-[9px]">
          View API Docs
          <ArrowRight className="size-2.5 sm:size-3" strokeWidth={2.5} aria-hidden />
        </span>
      </div>
    </div>
  );
}
